import { render, staticRenderFns } from "./updateDialog.vue?vue&type=template&id=573a91d6"
import script from "./updateDialog.vue?vue&type=script&lang=ts"
export * from "./updateDialog.vue?vue&type=script&lang=ts"
import style0 from "./updateDialog.vue?vue&type=style&index=0&id=573a91d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports